/* eslint-disable require-jsdoc */
/* eslint-disable flowtype/no-types-missing-file-annotation */
import { AxiosStatic } from 'axios';
import { hostName } from './axiosConfig';
/* import MD5 from 'crypto-js';

function getGravatar(email) {
    var hash = MD5(email);
    return "https://www.gravatar.com/avatar/" + hash + ".jpg";
} */

export default class MeetService {
    axios;
    constructor(axios: AxiosStatic, domain) {
        this.axios = axios;
        this.domain = domain;
    }
    async getMeetingData(meetingId) {
        const user = await this.axios.get(`meetings/${meetingId}`);

        return user.data;
    }
    async createData(room) {
        let d = Date.now() / 1000 - (24*60*60);
        return await this.axios.post('/meetings', {
            aud: 'panthermediasystem',
            authRoom: room,
            avatar: 'https://api.dicebear.com/5.x/shapes/svg?seed=guest-id',
            email: '',
            affiliation: "member",
            hiddenfromrecorder: "false",
            recording: "false",
            livestreaming: "false", 
            screensharing: "true",
            sipoutboundcall: "false",
            transcription: "true",
            exp: 24,
            fullURL: '',
            pantherURL: '',
            group: 'panther-connect',
            iss: 'FH92lBtaBxJf_WJqECMQs@j8Mr^ExtpU',
            nbf: d, 
            name: 'Guest',
            room,
            sub: `${hostName}`,
            userId: 'guest-id'
        });

    }
    async createMeeting(room, name = '', email ='', id='guest-id') {
        // var avatar = getGravatar(email);
        let d = Date.now() / 1000 - (24*60*60);

        return await this.axios.post('/meetings', {
            aud: 'panthermediasystem',
            authRoom: room,
            avatar: `https://api.dicebear.com/5.x/shapes/svg?seed=${id}`,
            email,
            affiliation: "owner",
            hiddenfromrecorder: "false",
            recording: "true",
            livestreaming: "true", 
            screensharing: "true",
            sipoutboundcall: "true",
            transcription: "true",
            exp: 24,
            fullURL: '',
            pantherURL: '',
            group: 'panther-connect',
            iss: 'FH92lBtaBxJf_WJqECMQs@j8Mr^ExtpU',
            nbf: d,  // time number that meeting will not be available before
            name,
            room,
            sub: `${hostName}`,
            userId: id
        });

    }
}
